export class RRWebviewerJsonSingle {
  jsonObj: any;
  // {
  //   version:number;
  //   scene:{
  //     defaultEnvironment?:any;
  //     materials?:any;
  //     nodes?:Array<any>;
  //   };
  // };
}
